// Groups
div.group(al-repeat='group in editor.groups',
  :style.transform='"translate("+group.position[0]+"px,"+group.position[1]+"px)"',
  :style.width='group.width+"px"',
  :style.height='group.height+"px"',
  al-group,
  :class.selected='editor.selected.contains(group)'
  )
  div.group-title(al-group-title)
    | {{group.title}}
  div.group-handler.right.bottom(al-group-handler='rb')
  div.group-handler.left.top(al-group-handler='lt')
  div.group-handler.left.bottom(al-group-handler='lb')
  div.group-handler.right.top(al-group-handler='rt')

// Connections
svg.connections
  path.connection(
    al-repeat='path in editor.paths',
    :d='path.d'
    al-connection
    :class.selected='path.selected'
  )

// Nodes
div.node(al-repeat='node in editor.nodes',
  :style.transform='"translate("+node.position[0]+"px,"+node.position[1]+"px)"',
  al-node,
  :data-id="node.id",
  class="{{editor.selected.contains(node)?'selected':''}} {{node.title.toLowerCase().replace(' ','-')}}"
  )
  div(al-html="editor.view.getTemplate(node)")
